export default "__VITE_ASSET__DgeaKJbT__"